<template>
  <div class="staking-features-container">
    <div class="staking-features-grid">
      <div class="staking-feature-box">
        <v-icon style="width: 45px;height: 45px">$earnIcon</v-icon>
        <span class="feature-title">{{
          $t("staking.features.feature1.title")
        }}</span>
        <p class="gray2--text font-Regular-14">
          {{ $t("staking.features.feature1.description") }}
        </p>
      </div>

      <div class="staking-feature-box">
        <v-icon style="width: 45px;height: 45px">$securityIcon</v-icon>
        <span class="feature-title">{{
          $t("staking.features.feature2.title")
        }}</span>
        <p class="gray2--text font-Regular-14">
          {{ $t("staking.features.feature2.description") }}
        </p>
      </div>

      <div
        class="multiStakingSection d-flex align-center justify-space-between"
      >
        <div>
          <span class="feature-title">{{
            $t("staking.features.feature3.title")
          }}</span>
          <p class="gray2--text font-Regular-14 mt-4" style="width: 80%;">
            {{ $t("staking.features.feature3.description") }}
          </p>
        </div>
        <div>
          <v-icon class="icon-desktop-only" style="width: 250px;height: 250px"
            >$multiStakingIcon</v-icon
          >
        </div>
      </div>

      <div class="staking-feature-box">
        <v-icon style="width: 45px;height: 45px">$earnIcon</v-icon>
        <span class="feature-title">{{
          $t("staking.features.feature4.title")
        }}</span>
        <p class="gray2--text font-Regular-14">
          {{ $t("staking.features.feature4.description") }}
        </p>
      </div>

      <div class="staking-feature-box">
        <v-icon style="width: 45px;height: 45px">$securityIcon</v-icon>
        <span class="feature-title">{{
          $t("staking.features.feature5.title")
        }}</span>
        <p class="gray2--text font-Regular-14">
          {{ $t("staking.features.feature5.description") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StakingFeatures"
};
</script>

<style scoped>
.staking-features-container {
  background-color: var(--v-gray10-base);
  border-radius: 1rem;
  margin-top: 1.25rem;
  overflow: hidden;
}

.staking-features-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  border-top: 1px solid var(--v-gray4-base);
}

.multiStakingSection {
  flex-direction: column;
  padding: 2rem 3rem;
  border-bottom: 1px solid var(--v-gray4-base);
  gap: 1rem;
}

@media (min-width: 768px) {
  .staking-features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .multiStakingSection {
    grid-column: 1/-1;
    flex-direction: row;
  }
}

.staking-feature-box {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 3rem;
  border-bottom: 1px solid var(--v-gray4-base);
}

.full-width {
  grid-column: span 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.feature-title {
  font-size: 20px;
  font-weight: 500;
}

.mt-4 {
  margin-top: 1rem;
}

.icon-desktop-only {
  display: none;
}

@media (min-width: 768px) {
  .icon-desktop-only {
    display: block;
  }
}
</style>
